import { render, staticRenderFns } from "./ProductionTab.vue?vue&type=template&id=4aed3d9a&"
import script from "./ProductionTab.vue?vue&type=script&lang=js&"
export * from "./ProductionTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports